import React from 'react'
import { Navbar,Nav,NavDropdown,Form,FormControl,Button,Dropdown } from 'react-bootstrap'

const navsize = "1.3em"
const menu = {
    "en":{
        "home":"HOME", "about":"ABOUT", "category":"CATEGORY", "apply":"APPLY", "awards":"AWARDS","ourproduct":"Our Products", "magazine":"Magazine & Gallery","dropdown":"Drop Down","rtprice":"Real-time Prices","fnews":"Financial News","histprice":"Historical Data","riskman":"Risk Management","traderecord":"Trade Record","memberrank":"Memberships", "terms":"RULES","jury":"JURY","contact":"CONTACT","links":"LINKS", "winners":"WINNERS", "scholarship":"SCHOLARSHIP"
    },
    "zh":{
        "home":"主頁", "quote":"實時報價", "aboutus":"關於我們", "awards":"Awards", "ourservice":"我們的業務","ourproduct":"我們的產品", "dropdown":"更多","rtprice":"實時市場價格","fnews":"財經新聞","histprice":"歷史價格圖表","riskman":"風險管理及入市計劃","traderecord":"交易詳情","memberrank":"會員階級制度"
    },
    "cn":{
        "home":"主页", "quote":"实时报价", "aboutus":"关于我们", "awards":"Awards","ourservice":"我们的业务","ourproduct":"我们的产品", "dropdown":"更多","rtprice":"实时市场价格","fnews":"财经新闻","histprice":"历史价格图表","riskman":"风险管理及入市计划","traderecord":"交易详情","memberrank":"会员阶级制度"
    },
}

class ISWCNavBarTop extends React.Component{
    constructor(props){
        super(props);
        this.state = {  
          
        };
    
        this.clicknav = this.clicknav.bind(this)

      }
componentDidMount(){
    document.title="International English Speech Art and Writing Competition"
    var link1 = document.getElementById('favicon')
    var link2 = document.getElementById('touchicon')
    link1.href="/assets/iswc-logo.PNG"
    link2.href="/assets/iswc-logo.PNG"
    this.props.setval({comp:"iswc",lang:"en"})
}
      clicknav(page,pos){
        if(page===this.props.pageSelected){
            document.getElementById(pos).scrollIntoView();
        }else {
            this.props.setval({pageSelected:page,pagepos:pos});           
        } 
      }
//{this.props.companyname[this.props.lang]}
    render(){
        return(
            <div>
                <div className="row">
                    <div className={["col-md-12","fullwidth"].join(" ")}>
                       
                            <Navbar style={{background:"#0d4200",background:"linear-gradient(90deg,rgba(10, 56, 0, 1) 0%, rgb(20, 82, 45) 83%, rgb(70, 100, 21) 100%)"}} expand="lg" collapseOnSelect >
                                <Navbar.Brand className="navbar-brand" ><img src="../assets/iswc-logo.PNG" width="120px" height="80px"/></Navbar.Brand>
                                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                <Navbar.Collapse className="navbar-collapse" id="basic-navbar-nav">
                                    <Nav className="mr-auto">
                                    {/* <Nav.Link className={"navbar-gold"} style={{fontFamily:"Courgette",fontSize:navsize,color:"rgba(125, 104, 0,1)",fontWeight:"bold",marginLeft:"10px"}} href="/iswc" onClick={(e)=>{
                                        //this.props.setval({pageSelected:"home"})
                                        }}>{menu[this.props.lang]["home"]}</Nav.Link> */}
                                         <NavDropdown id={"iswc-home"} style={{fontFamily:"Courgette",fontSize:navsize,fontWeight:"bold",marginLeft:"10px",color:"gold"}} title={menu[this.props.lang]["home"]}>
                                         <NavDropdown.Item href="/iswc">{menu[this.props.lang]["home"]}</NavDropdown.Item>
                                            <NavDropdown.Item href="/iswc/magazine" >{menu[this.props.lang]["magazine"]}</NavDropdown.Item>
                                        </NavDropdown>
                                    <Nav.Link className={"navbar-gold"} style={{fontFamily:"Courgette",fontSize:navsize,color:"rgba(125, 104, 0,1)",fontWeight:"bold",marginLeft:"10px"}} href="/iswc/about" onClick={(e)=>{
                                        //this.props.setval({pageSelected:"about"})
                                        }}>{menu[this.props.lang]["about"]}</Nav.Link>
                                    <Nav.Link className={"navbar-gold"} style={{fontFamily:"Courgette",fontSize:navsize,color:"rgba(125, 104, 0,1)",fontWeight:"bold",marginLeft:"10px"}} href="/iswc/apply"onClick={(e)=>{
                                        //this.props.setval({pageSelected:"apply"})
                                        }}>{menu[this.props.lang]["apply"]}</Nav.Link>
                                    <Nav.Link className={"navbar-gold"} style={{fontFamily:"Courgette",fontSize:navsize,color:"rgba(125, 104, 0,1)",fontWeight:"bold",marginLeft:"10px"}} href="/iswc/category" onClick={(e)=>{
                                        //this.props.setval({pageSelected:"category"})
                                        }}>{menu[this.props.lang]["category"]}</Nav.Link>
                                    <Nav.Link className={"navbar-gold"} style={{fontFamily:"Courgette",fontSize:navsize,color:"rgba(125, 104, 0,1)",fontWeight:"bold",marginLeft:"10px"}} href="/iswc/awards" onClick={(e)=>{
                                        //this.props.setval({pageSelected:"awards"})
                                        }}>{menu[this.props.lang]["awards"]}</Nav.Link>
                                    <Nav.Link className={"navbar-gold"} style={{fontFamily:"Courgette",fontSize:navsize,color:"rgba(125, 104, 0,1)",fontWeight:"bold",marginLeft:"10px"}} href="/iswc/terms" onClick={(e)=>{
                                        //this.props.setval({pageSelected:"terms"})
                                        }}>{menu[this.props.lang]["terms"]}</Nav.Link>
                                      <Nav.Link className={"navbar-gold"} style={{fontFamily:"Courgette",fontSize:navsize,color:"rgba(125, 104, 0,1)",fontWeight:"bold",marginLeft:"10px"}} href="/iswc/jury" onClick={(e)=>{
                                        //this.props.setval({pageSelected:"terms"})
                                        }}>{menu[this.props.lang]["jury"]}</Nav.Link>
                                    <Nav.Link className={"navbar-gold"} style={{fontFamily:"Courgette",fontSize:navsize,color:"rgba(125, 104, 0,1)",fontWeight:"bold",marginLeft:"10px"}} href="/iswc/contact" onClick={(e)=>{
                                        //this.props.setval({pageSelected:"jury"})
                                        }}>{menu[this.props.lang]["contact"]}</Nav.Link>
                                    <Nav.Link className={"navbar-gold"} style={{fontFamily:"Courgette",fontSize:navsize,color:"white",fontWeight:"bold",marginLeft:"10px"}} href="/iswc/scholarship" onClick={(e)=>{
                                        //this.props.setval({pageSelected:"jury"})
                                        }}>{menu[this.props.lang]["scholarship"]}</Nav.Link>
                                    {/* <Nav.Link className={"navbar-gold"} style={{fontFamily:"Courgette",fontSize:navsize,color:"rgba(125, 104, 0,1)",fontWeight:"bold",marginLeft:"10px"}} href="/iswc/links" onClick={(e)=>{
                                        //this.props.setval({pageSelected:"jury"})
                                        }}>{menu[this.props.lang]["links"]}</Nav.Link> */}
                                    <NavDropdown id={"iswc-nav-winner"} style={{fontFamily:"Courgette",fontSize:navsize,color:"rgba(125, 104, 0,1)",fontWeight:"bold",marginLeft:"10px"}} title={menu[this.props.lang]["winners"]}>
                                        <NavDropdown.Item href="/iswc/winners" onClick={(e)=>{
                                            localStorage.setItem("winneryear","2025")
                                        }}>{"2025"+ menu[this.props.lang]["winners"]}</NavDropdown.Item>
                                        {/* <NavDropdown.Item href="/icmt/teacherlist" >{menu[this.props.lang]["teacherlist"]}</NavDropdown.Item> */}
                                    </NavDropdown>
                                   <img src={"/assets/yt_logo.PNG"} alt={"YT_LOGO"} height={"65px"} className={"nav-ytlogo"} />

                                    </Nav>
                                   
                                </Navbar.Collapse>
                            </Navbar>
                         
                    </div>
                </div>
            </div>
        )  
    }
}

export default ISWCNavBarTop;